import React, { Component } from 'react';
import { Input, Button, Card } from 'reactstrap';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import './NavMenu.css';
import { AppContext } from '../AppContext';
import { HiDocumentDownload, HiDocumentText } from 'react-icons/hi';
import AllPagesPDFViewer from './All-page';
import Select from "react-select/creatable";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import url from "./variables/url.js";
/*import history from "../history";*/

/*const localBack = url.localBack;*/
const localBack = process.env.REACT_APP_BACK;
const homepage = process.env.REACT_APP_EXP;
const MySwal = withReactContent(Swal)

const gestionErr = {
    "idaexregistroactividadgestion": 0,
    "idaexregistroactividad": 0,
    "estado": "R",
    "comentarios": "Error al ingresar, no se genero el primer estado inicial de la actividad.",
    "idresponsable": 0,
    "fecha": "",
    "ultimoCambio": ""
}

export class UpdateGestion extends Component {
    static displayName = UpdateGestion.name;

    constructor(props) {
        super(props);
        this.state = {
            /*estructura registro actividad*/
            edit: false,            
            loading: true,
            iduser: 0,
            roles: [],
            actividad: {
                idaexregistroactividad: 0,
                categoria: 1,
                idaextipoactividad: 2,
                descripcionact: '',
                nombre: '',
                anio: '',
                horas: 0,
                evidencia: '',
                descripcionevid: '',
                tutor: '',
                puesto: '',
                instacredita: 0,
                idestudiante: 91227,
                revisado: 0,
            },            
            gestion: {
                idaexregistroactividad: 0,
                idresponsable: 0,
                comentarios: '',
                estado: ''                
            },
            persona: {
                idpersona: 0,
                numeroidentificacion: "",
                apellidos: "",
                nombres: "",
                codestudiante: "",
                email: "",
                sexo: "",
                estadopersona: "A",
                tipodiscapacidad: "N",
                tipoidentificacion: "CED",
                estadoempleado: "",
                tienediscapacidad: "N",
                tienefamildiscapacidad: "N"
            },            
            insignias: [],
            tipos: [],
            instituciones: [],
            institucionesSelect: [],
            institucionesInternas: [{ 'value': 'UNIDAD', 'label': 'Unidad' }, { 'value': 'ASOCIACION', 'label': 'Asociaci\u00F3n' }, { 'value': 'CLUBES', 'label': 'Clubes' }, { 'value': 'FEDERACION', 'label': 'Federaci\u00F3n' }, { 'value': 'ESPOL', 'label': 'INTERNO' }],
            selectedInstInterna: { 'value': 'UNIDAD', 'label': 'Unidad' },
            currentUser: [],
            classInstitucion: [{ 'value': 2, 'label': 'ESPOL' }, { 'value': 'EXTERNA', 'label': 'Externa' }],
            selectedClassInst: { 'value': 2, 'label': 'ESPOL' },
            selectedInst: {},
            openModal: false,
            pdfBase64: '',
            pdfResult: 0,
            /*I para Ingresado, A para Aprobado y R para Rechazado.*/
            estados: [ { id: 'R', nombre: 'Rechazado' }, {id:'D',nombre:'Devuelto'},{ id: 'A', nombre: 'Aprobado'}],            
            estadosErr: [{ id: 'I', nombre: 'Ingresado' },{ id: 'R', nombre: 'Rechazado' }, {id:'D',nombre:'Devuelto'},{ id: 'A', nombre: 'Aprobado'}]
        };        

        // This binding is necessary to make "this" work in the callback        
        this.handleSave = this.handleSave.bind(this);
        this.handleCancel = this.handleCancel.bind(this);       
        this.onChangeEstado = this.onChangeEstado.bind(this);
        this.handleArea = this.handleArea.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
    }

    componentDidMount() {        
        var actid = this.props.match.params["id"];        
        if (actid > 0) {
            this.setState({ loading: true, edit: true });
            this.populateActividadData(actid);            
        }
        this.populateInfoData();
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    componentDidUpdate() {
        let currentUser = this.context;
        if (currentUser != null && this.state.iduser == 0) {
            this.setState({ iduser: currentUser.idpersona, roles: currentUser.roles });
            if (currentUser.roles.includes('ADMINISTRADOR')) {
                //console.log('Ok');
            } else {
                this.isForbidden();
            }

        }
    }

    isForbidden() {
        this.props.history.push({
            pathname: homepage,
        })
    }

    handleSave(event) {
        const currentUser = this.context;
        //console.log("Gestionar");
        let forma = new FormData(event.target);        
        let gestion = this.state.gestion;
        forma.forEach((value, clave) => {
            if (typeof gestion[clave] === 'number') {
                gestion[clave] = Number(value);
            }
            else if (typeof gestion[clave] === 'boolean') {
                //console.log(Boolean(value));

                gestion[clave] = Boolean(value);
            }
            else if (value == '') {
                gestion[clave] = null;
            }
            else {
                gestion[clave] = value;
            }
        });

        gestion.idaexregistroactividadgestion = 0;
        gestion.idresponsable = currentUser.idpersona;
        gestion.responsable = null;
        gestion.idaexregistroactividad = this.state.actividad.idaexregistroactividad;

        //console.log(gestion);

        if (gestion.idresponsable > 0) {
            const data = JSON.stringify(gestion);

            fetch(localBack + '/api/RegistroActividad/PostGestion/', {

                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: data,

            })
                .then((response) => {
                    let resp = response.json();
                    /*console.log(response.objDatos)*/
                    return resp;
                    /*this.props.location.props.onUpdateActividades(response.objDatos)*/
                }).then(data => {
                    //console.log(data.strMensaje);
                    if (data.strEstado == 'S') {
                        this.setState({ actividad: data.objDatos, loading: false, total: 1, gestion: data.objDatos.registroActividadGestion });                        
                        MySwal.fire({
                            icon: 'success',
                            title: 'Actualizaci\u00F3n de Estado',
                            text: 'Se actualizo el estado.',
                            confirmButtonText: 'Listo',
                            /*timer: 5000*/
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.gotoGestion(data);
                            }
                        })
                    } else {
                        this.setState({ loading: false });
                        MySwal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Error al actulizar estado.',
                            confirmButtonText: 'salir',
                            /*timer: 5000*/
                        })
                    }
                })
        }        

        else {
            //console.log("No hubo id");
        }                
        /*this.props.history.push('/GestionActividad');*/
        event.preventDefault();
    }

    gotoGestion(data) {
        this.props.history.push({ pathname: homepage + 'GestionActividad', state: { actividad: data.objDatos } });
    }

    handleCancel() {
        //console.log("Cancelar");
        this.props.history.push(homepage + "GestionActividad");
    }     

    onChangeEstado(e) {
        //console.log('Cambio Estado');
        //console.log(e.target.value);
        var id = e.target.value;
        var gest = this.state.gestion;
        gest.estado = id;
        if (id === 'A') {
            gest.comentarios = 'Actividad Aprobada.'
        } else if (id === 'R') {
            gest.comentarios = ''
        }else {
            gest.comentarios = ''
        }
        this.setState({ gestion: gest });
        //console.log(this.state.gestion);
    }

    handleArea(event) {
        let gest = this.state.gestion;
        gest.comentarios = event.target.value
        this.setState({ gestion: gest });
    }

    getPdf(link) {        
        //console.log(link);
        let cortar = this.state.actividad.evidencia.split('/');
        let total = cortar.length;
        fetch(link, {
            method: 'GET',
        })
            .then(response => {                
                this.setState({ status: response.status });
                return response.json();
            })
            .then(data => {                
                if (data !== '') {
                    this.setState({
                        pdfBase64: "data:application/pdf;base64," + data + "", pdfResult: 1, openModal: false
                    });
                    //console.log(total);
                    //console.log(cortar[total-1]);                    
                    let a = document.createElement('a');
                    a.href = "data:application/pdf;base64," + data + "";
                    a.download = "evidencia-" + this.state.actividad.nombre + ".pdf";
                    a.click();
                } else {
                    this.setState({ pdfResult: -1 });
                }                
            });
    }

    openInNewTab = url => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    abrirDoc(link) {
        if (link !== null) {
            if (link.startsWith(localBack + '/api/FileUpload/DescargarEvidencia/')) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    cerrarModal() {        
        this.setState({
            openModal: !this.state.openModal
        });
    }

     renderUpdateGestionTable(insignias, tipos, instituciones) {
         
         return (
             <div className="col-md-12">

                 <div className="form">
                     <Input type="hidden" name="idaexregistroactividad" value={this.state.actividad.idaexregistroactividad} />
                     <Input type="hidden" name="idestudiante" value={this.state.actividad.idestudiante} />
                     <Input type="hidden" name="revisado" value={this.state.actividad.revisado} />

                     <div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">Estudiante: </label>
                         <Input className="form-control col-md-10" type="text" name="nombre" value={this.state.persona.apellidos + ' ' + this.state.persona.nombres } readOnly />
                     </div>
                     <div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">{this.nombrePorTipo(this.state.actividad.idaextipoactividad)} </label>
                         <Input className="form-control col-md-10" type="text" name="nombre" defaultValue={this.state.actividad.nombre} readOnly />
                     </div>
                     <div className="form-group row" >
                         <label className="control-label col-md-5" htmlFor="Name">Descripci&oacute;n Actividad:</label>
                         <Input type="textarea" rows="3" name="descripcionact" defaultValue={this.state.actividad.descripcionact} readOnly />
                     </div>
                     <div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">Competencia: </label>
                         <Input className="form-control col-md-10" type="select" onChange={this.onChangeCategoria} value={this.state.actividad.categoria} disabled>
                             {insignias.map(insignia =>
                                 <option key={insignia.idaexinsignia} selected={insignia.idaexinsignia == this.state.actividad.categoria ? true : false} value={insignia.idaexinsignia}>{insignia.nombre}</option>
                             )
                             }
                         </Input>
                     </div>
                     <div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">Tipo: </label>
                         <Input className="form-control col-md-10" type="select" onChange={this.onChangeTipo} value={this.state.actividad.idaextipoactividad} disabled>
                             {tipos.map(tipo =>
                                 <option key={tipo.idaextipoactividad} selected={tipo.idaextipoactividad == this.state.actividad.idaextipoactividad ? true : false} value={tipo.idaextipoactividad}>{tipo.nombre}</option>
                             )
                             }
                         </Input>
                     </div>
                     <div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">A&ntilde;o: </label>
                         <Input className="form-control col-md-4" type="text" name="anio" defaultValue={this.state.actividad.anio} readOnly />
                         {this.usoHora(this.state.actividad.idaextipoactividad)
                             ? <>< label className="control-label col-md-1" htmlFor="Name">Horas: </label>
                                 <Input className="form-control col-md-4" type="text" name="horas" defaultValue={this.state.actividad.horas} readOnly /></>
                             : <></>}
                     </div>                     
                     <div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">Evidencia: </label>
                         <Input className="form-control col-md-5" type="text" name="evidencia" defaultValue={this.state.actividad.evidencia} readOnly />
                         {this.state.actividad.evidencia !== '' ? this.abrirDoc(this.state.actividad.evidencia)
                             ? <Button className="btn-info btn-round" onClick={() => this.getPdf(this.state.actividad.evidencia)} ><HiDocumentDownload /></Button>
                             : this.state.actividad.evidencia === '' ? <></> : <Button className="btn-info btn-round" onClick={() => this.openInNewTab(this.state.actividad.evidencia)} ><HiDocumentText /></Button> : <></>}
                         
                     </div>                     
                     <div className="form-group row" >
                         {this.usoInstitucion(this.state.actividad.idaextipoactividad) ?
                             <>
                                 <label className="control-label col-md-2" htmlFor="Name">Tipo Instituci&oacute;n: </label>
                                 <Select className="col-md-4" value={this.state.selectedClassInst} onChange={this.onChangeClassInst} options={this.state.classInstitucion} isDisabled />
                             </>
                             : <></>}
                     </div>
                     <div className="form-group row" >
                         {this.usoTutor(this.state.actividad.idaextipoactividad) ?
                             <><label className="control-label col-md-1" htmlFor="Name"> {this.tutorPorTipo(this.state.actividad.idaextipoactividad)} </label>
                                 <Input className="form-control col-md-4" type="text" name="tutor" defaultValue={this.state.actividad.tutor} required /></>
                             : <></>}
                     </div>
                     {this.state.selectedClassInst.label === 'ESPOL' ?
                         <div className="form-group row" >
                             {this.usoInstitucion(this.state.actividad.idaextipoactividad) ?
                                 <>
                                     <label className="control-label col-md-2" htmlFor="Name">Clasificaci&oacute;n: </label>
                                     <Select className="col-md-4" value={this.state.selectedInstInterna} onChange={this.onChangeInstInterna} options={this.state.institucionesInternas} isDisabled />
                                 </>
                                 : <></>}
                             {this.usoInstitucion(this.state.actividad.idaextipoactividad) ?
                                 <>
                                     <label className="control-label col-md-2" htmlFor="Name">Instituci&oacute;n: </label>
                                     <Select className="col-md-4" value={this.state.selectedInst} onChange={this.onChangeInst} options={instituciones.filter(i => i.clasificacion === this.state.selectedInstInterna.value)} isDisabled />
                                 </>
                                 : <></>}
                         </div>
                         :
                         <div className="form-group row" >
                             {this.usoInstitucion(this.state.actividad.idaextipoactividad) ?
                                 <>
                                     <label className="control-label col-md-2" htmlFor="Name">Instituci&oacute;n: </label>
                                     <Select className="col-md-4" value={this.state.selectedInst} onChange={this.onChangeInst} options={instituciones.filter(i => i.clasificacion === 'EXTERNA')} isDisabled />
                                 </>
                                 : <></>}

                             {
                                 <>
                                     <label className="control-label col-md-2" htmlFor="Name">Contacto: </label>
                                     <Input className="form-control col-md-4" type="email" name="contacto" defaultValue={this.state.actividad.contacto} readOnly />
                                 </>
                             }
                         </div>
                     }
                     {this.usoPuesto(this.state.actividad.idaextipoactividad)
                         ? < div className="form-group row" >
                             <label className="control-label col-md-2" htmlFor="Name">Puesto: </label>
                             <Input className="form-control col-md-4" type="text" name="puesto" defaultValue={this.state.actividad.puesto} readOnly />
                         </div> : <></>}
                     <div className="form-group row" >
                         <label className="control-label col-md-5" htmlFor="Name">Descripci&oacute;n Evidencia:</label>
                         <Input type="textarea" rows="3" name="descripcionevid" defaultValue={this.state.actividad.descripcionevid} readOnly />
                     </div>
                 </div>
                 
                 <form className="col-md-12" onSubmit={this.handleSave} >
                     <Input type="hidden" name="idaexregistroactividad" value={this.state.gestion.idaexregistroactividad} />
                     <Input type="hidden" name="idresponsable" value={this.state.gestion.idresponsable} />

                     <div className="form-group row" >
                         <label className="control-label col-md-2" htmlFor="Name">Estado: </label>
                         <Input className="form-control col-md-10" type="select" onChange={this.onChangeEstado} value={this.state.gestion.estado}>
                             {this.state.estadosErr.map(est =>
                                 <option key={est.id} selected={this.state.gestion.estado == est.id ? true : false} value={est.id}>{est.nombre}</option>
                             )
                             }
                         </Input>
                     </div>

                     <div className="form-group row" >
                         <label className="control-label col-md-5" htmlFor="Name">Comentario:</label>
                         <Input type="textarea" rows="3" name="comentarios" value={this.state.gestion.comentarios} onChange={this.handleArea} required />
                     </div>

                     <div className="form-group row menu">
                         <label className=" control-label col-md-6" htmlFor="Name"></label>
                         <div className="col-md-6">
                             <Button className="btn-info btn-round" type='submit'>Enviar</Button>
                             &nbsp;&nbsp;&nbsp;
                             <Button className="btn-warning btn-round" onClick={this.handleCancel}>Cancelar</Button>
                         </div>
                     </div >
                 </form>

              </div>
        );
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderUpdateGestionTable(this.state.insignias, this.state.tipos, this.state.instituciones);

        return (
            <div>
                <h1 id="tabelLabel" >Gesti&oacute;n Actividad</h1>
                {contents}

                <Modal size="xl" isOpen={this.state.openModal} toggle={() => this.cerrarModal()} className={this.props.className}>
                    <ModalHeader toggle={() => this.cerrarModal()}>Vista Evidencia</ModalHeader>
                    <ModalBody>
                        <Card  body className="all-page-container" style={{ alignContent: 'center', height: '100%', maxHeight: '500px', overflow: 'auto' }}>
                            {this.state.pdfResult > 0 ? <AllPagesPDFViewer pdf={this.state.pdfBase64} /> : <>No pdf</>}
                        </Card>
                    </ModalBody>
                    <ModalFooter>
                        <Button hidden color="primary" onClick={() => this.cerrarModal()}>Descargar</Button>{' '}
                        <Button color="secondary" onClick={() => this.cerrarModal()}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }    

    populateActividadData(id) {
        let instSel = {};
        let instClassSel = {};
        let instInternaSel = { 'value': 'UNIDAD', 'label': 'Unidad' };        
        let bandera = true
        fetch(localBack + '/api/RegistroActividad/GetWithGestion/' + id, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status });
                return response.json();
            })
            .then(data => {
                //console.log(data);
                if (data.strEstado == 'S') {
                    instSel = this.state.instituciones.filter(i => i.value === data.objDatos.idinstitucion);
                    if (data.objDatos.institucion.clasificacion === 'EXTERNA') {
                        //console.log('EXTERNA');
                        instClassSel = { 'value': 'EXTERNA', 'label': 'Externa' };
                    } else {
                        //console.log('ESPOL');
                        instClassSel = { 'value': 2, 'label': 'ESPOL' };
                        instInternaSel = this.state.institucionesInternas.filter(i => i.value === data.objDatos.institucion.clasificacion);
                    }
                    this.setState({
                        actividad: data.objDatos,
                        persona: data.objDatos.estudiante,
                        loading: false,
                        total: 1,
                        gestion: data.objDatos.registroActividadGestion,
                        selectedInst: instSel,                        
                        selectedClassInst: instClassSel,
                        selectedInstInterna: instInternaSel,
                    });
                    bandera = false;
                    //console.log(this.state.persona);
                } else {
                    this.setState({ loading: false, gestion: gestionErr });                    
                }
            });

        if (bandera) {
            //console.log("Populate actividad" + id);
            fetch(localBack + '/api/RegistroActividad/' + id, {
                method: 'GET',
                /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
            })
                .then(response => {
                    this.setState({ status: response.status });
                    return response.json();
                })
                .then(data => {
                    //console.log(data.strMensaje);
                    if (data.strEstado == 'S') {
                        this.setState({ actividad: data.objDatos, loading: false });
                    }
                });
        }
        //console.log('Actividad: ',this.state.actividad);
        //console.log('Gestion: ',this.state.gestion);
    }

    populateActividad(id) {
        //console.log("Populate actividad" + id);
        fetch(localBack + '/api/RegistroActividad/' + id, {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => {
                this.setState({ status: response.status });
                return response.json();
            })
            .then(data => {
                //console.log(data.strMensaje);
                if (data.strEstado == 'S') {
                    this.setState({ actividad: data.objDatos, loading: false });
                } else {
                    this.setState({ loading: false, actividad: [] });
                }
            });
    }

    populateGestionData(id) {
        //console.log("Gestion " + id);
        let gestionId = this.state.gestion;
        gestionId.idresponsable = 2567;
        gestionId.idaexregistroactividad = id;
        this.setState({ gestion: gestionId });
        //console.log(this.state.gestion);
        //fetch(localBack + '/api/RegistroActividad/' + id, {
        //    method: 'GET',
        //    /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        //})
        //    .then(response => {
        //        this.setState({ status: response.status });
        //        return response.json();
        //    })
        //    .then(data => {
        //        console.log(data.strMensaje);
        //        if (data.strEstado == 'S') {
        //            this.setState({ actividad: data.objDatos, loading: false, total: 1 });
        //        } else {
        //            this.setState({ loading: false });
        //        }
        //    });
    }

    populateInfoData() {
        let ids = [];
        fetch(localBack + '/api/Insignia', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data.strMensaje);*/
                this.setState({
                    insignias: data.objDatos
                });
            });

        fetch(localBack + '/api/TipoActividad/GetOnlyActive', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    tipos: data.objDatos,
                    loading: false
                });
            });

        fetch(localBack + '/api/Entidad', {
            method: 'GET',
            /*headers: { "Authorization": `Bearer ${getCookie('token')}` },*/
        })
            .then(response => response.json())
            .then(data => {
                data.objDatos.map(inst => { ids.push({ 'value': inst.idaexentidad, 'label': inst.nombre, 'clasificacion': inst.clasificacion }) });
                this.setState({
                    instituciones: ids,
                    institucionesSelect: ids,
                    loading: false
                });
            });

    }

    nombrePorTipo(tipo) {
        if (tipo === 1 || tipo === 13 || tipo === 16 || tipo === 25)
            return 'Nombre del Proyecto: '
        else if (tipo === 2 || tipo === 3)
            return 'Nombre del Reto: '
        else if (tipo === 5 || tipo === 8 || tipo === 14 || tipo === 17 || tipo === 19 || tipo === 27 || tipo === 28 || tipo === 29)
            return 'Nombre del Curso: '
        else if (tipo === 20)
            return 'Nombre de la Materia: '
        else if (tipo === 21)
            return 'Nombre de la Unidad: '
        else if (tipo === 10 || tipo === 12)
            return 'Nombre del Cargo: '
        else if (tipo === 26)
            return 'Nombre del Deporte: '
        else if (tipo === 22)
            return 'Mentoring Edici\u00F3n: '
        else if (tipo === 23)
            return 'Nombre del Torneo: '
        else
            return 'Nombre de Actividad: '
    }

    tutorPorTipo(tipo) {
        if (tipo === 22)
            return 'Mentor: '
        else
            return 'Tutor: '
    }

    usoTutor(tipo) {
        let ids = [1, 22]
        let respuesta = false;
        if (ids.includes(tipo))
            respuesta = true;
        return respuesta;
    }

    usoHora(tipo) {
        let ids = [1, 2, 3, 5, 8, 9, 10, 12, 13, 14, 17, 19, 20, 21, 22, 23, 26, 27, 28, 29, 31, 32];
        if (ids.includes(tipo))
            return false;
        else
            return true;
    }

    usoPuesto(tipo) {
        let puesto = [23];
        let respuesta = false;
        if (puesto.includes(tipo))
            respuesta = true;
        return respuesta;
    }

    usoInstitucion(tipo) {
        let ids = [1, 2, 3, 5, 6, 8, 9, 13, 14, 16, 17, 19, 22, 23, 24, 25, 27, 28, 29];
        let respuesta = false;
        if (ids.includes(tipo))
            respuesta = true;
        return respuesta;
    }

}
UpdateGestion.contextType = AppContext;
